import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import IconButton from '../Button/IconButton.js';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledDialog = /*#__PURE__*/_styled(Dialog, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny846"
})(_ref => {
  let {
    theme,
    dialogRootStyle = {}
  } = _ref;
  return {
    '& .MuiPaper-root': _objectSpread2(_objectSpread2({
      maxWidth: '350px',
      borderRadius: '10px'
    }, dialogRootStyle), {}, {
      position: 'relative'
    })
  };
}, "");
const StyledDialogContentContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny845"
})(_ref2 => {
  return {
    padding: '48px 48px 32px'
  };
}, "");
const StyledDialogDialogTitle = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny844"
})(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    fontSize: '18px',
    fontWeight: theme.fontWeight.BOLD,
    marginBottom: '8px',
    padding: 0
  };
}, "");
const StyledCloseBtn = /*#__PURE__*/_styled(IconButton, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny843"
})(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    position: 'absolute',
    top: '12px',
    right: '12px',
    display: 'block',
    width: '24px',
    height: '24px',
    '& svg': {
      height: '100%',
      width: '100%'
    },
    '&:hover': {
      background: 'none',
      '& path': {
        transition: '0.3s',
        fill: theme.customColors.purple[500]
      }
    }
  };
}, "");
const StyledDialogContent = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny842"
})(_ref5 => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  };
}, "");
const StyledDialogContentInside = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny841"
})(_ref6 => {
  let {
    theme
  } = _ref6;
  return {
    color: theme.customColors.grey[600],
    textAlign: 'center',
    marginBottom: '16px'
  };
}, "");
const StyledButtonArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1hlny840"
})(_ref7 => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  };
}, "");
export { StyledButtonArea, StyledCloseBtn, StyledDialog, StyledDialogContent, StyledDialogContentContainer, StyledDialogContentInside, StyledDialogDialogTitle };